import request from '@/api/config.js'

export function getKkmConfig(orgId) {
  return request({
    url: `integrations/kkm-receipt/org/${orgId}/config`,
    method: 'get',
  })
}

export function getReceiptStatus(recordId) {
  return request({
    url: `integrations/kkm-receipt/${recordId}/status`,
    method: 'get',
  })
}

export function saveKkmResult(recordId, data) {
  return request({
    url: `integrations/kkm-receipt/${recordId}`,
    method: 'patch',
    data,
  })
}
